import { FC, MouseEvent, useEffect, useState } from "react";
import { useFormContext } from "react-hook-form";
import { FormattedMessage } from "react-intl";

import { IFilterDto } from "@framework/types";
import { useAsu } from "@framework/provider-asu";

import { ClearFormButton } from "../../../common/buttons/clear-form";
import { emptyFilters } from "../../../common/interfaces/empty-filters";
import { StyledButton } from "../../../common/styled/button";

export interface IFilterButtons {
  handleSubmit: (e: MouseEvent<HTMLButtonElement>) => void;
  onClose: () => void;
}

export const FilterButtons: FC<IFilterButtons> = props => {
  const { handleSubmit, onClose } = props;

  const form = useFormContext();
  const { isFilterApplied } = useAsu();

  const [memoizedValues, setMemoizedValues] = useState<IFilterDto | null>(null);

  const handleClose = () => {
    if (memoizedValues && isFilterApplied) {
      form.reset(memoizedValues);
    }
    onClose();
  };

  useEffect(() => {
    const values = form.getValues() as IFilterDto;
    setMemoizedValues(values);
  }, []);

  return (
    <>
      <ClearFormButton initialValues={emptyFilters} />
      <StyledButton size="small" onClick={handleClose} color="warning" sx={{ minWidth: 80, mb: 1 }}>
        <FormattedMessage id="form.buttons.cancel" />
      </StyledButton>
      <StyledButton size="small" onClick={handleSubmit} color="success" sx={{ minWidth: 80, mb: 1, mr: 2 }}>
        <FormattedMessage id="form.buttons.ok" />
      </StyledButton>
    </>
  );
};
